export default __webpack_public_path__ + "static/media/british.2f977a40.png";